import { useEffect, useState } from 'react';
import { adminApi } from '../../api/adminApi';

export default function ServicesAdmin() {
  const [services, setServices] = useState<any[]>([]);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [editId, setEditId] = useState<number | null>(null);

  // --- Стан для кастомного модального вікна ---
  const [modal, setModal] = useState<{
    show: boolean;
    title: string;
    message: string;
    onConfirm?: () => void;
    isConfirm?: boolean;
  }>({ show: false, title: '', message: '' });

  const showAlert = (title: string, message: string) => {
    setModal({ show: true, title, message, isConfirm: false });
  };

  const showConfirm = (title: string, message: string, onConfirm: () => void) => {
    setModal({ show: true, title, message, onConfirm, isConfirm: true });
  };

  const closeModal = () => setModal({ ...modal, show: false });
  // -------------------------------------------

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  const load = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/services`);
      const data = await res.json();
      setServices(data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const submit = async () => {
    if (!title.trim()) return showAlert('Увага', 'Будь ласка, введіть хоча б назву послуги');
    
    try {
      if (editId) {
        await adminApi.updateService(editId, { 
          title, 
          description: description.trim() || "" 
        });
        showAlert('Успіх', 'Послугу оновлено!');
      } else {
        await adminApi.createService({ 
          title, 
          description: description.trim() || "" 
        });
        showAlert('Успіх', 'Послугу додано!');
      }
      
      cancelEdit();
      load();
    } catch (err) {
      showAlert('Помилка', 'Не вдалося зберегти дані');
    }
  };

  const startEdit = (service: any) => {
    setEditId(service.id);
    setTitle(service.title);
    setDescription(service.description || '');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const cancelEdit = () => {
    setEditId(null);
    setTitle('');
    setDescription('');
  };

  const remove = async (id: number) => {
    showConfirm('Видалення', 'Ви впевнені, що хочете видалити цю послугу?', async () => {
      try {
        await adminApi.deleteService(id);
        load();
      } catch (err) {
        showAlert('Помилка', 'Помилка при видаленні');
      }
    });
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentServices = services.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(services.length / itemsPerPage);

  return (
    <div style={{ padding: '20px', maxWidth: '1000px', margin: '0 auto', fontFamily: 'Montserrat, sans-serif', backgroundColor: '#f0f7f4', minHeight: '100vh' }}>
      
      {/* КАСТОМНЕ МОДАЛЬНЕ ВІКНО */}
      {modal.show && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <h4 style={{ marginTop: 0, color: '#2d5a50' }}>{modal.title}</h4>
            <p style={{ color: '#666', fontSize: '15px' }}>{modal.message}</p>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px' }}>
              {modal.isConfirm && (
                <button onClick={closeModal} style={secondaryBtnStyle}>Скасувати</button>
              )}
              <button 
                onClick={() => { modal.onConfirm?.(); closeModal(); }} 
                style={primaryBtnStyle}
              >
                ОК
              </button>
            </div>
          </div>
        </div>
      )}

      <h2 style={{ color: '#2d5a50', borderBottom: '2px solid #1abc9c', paddingBottom: '10px', marginBottom: '30px' }}>
        🛠 Керування послугами
      </h2>

      <div style={{ 
        background: '#fff', padding: '25px', borderRadius: '12px', 
        boxShadow: '0 2px 8px rgba(0,0,0,0.05)', marginBottom: '40px',
        border: editId ? '2px solid #1abc9c' : 'none'
      }}>
        <h3 style={{ marginTop: 0, fontSize: '18px' }}>
          {editId ? ' Редагувати послугу' : ' Додати нову послугу'}
        </h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          <input
            placeholder="Назва послуги (обов'язково)"
            value={title}
            onChange={e => setTitle(e.target.value)}
            style={inputStyle}
          />
          <textarea
            placeholder="Детальний опис послуги (необов'язково)..."
            value={description}
            onChange={e => setDescription(e.target.value)}
            style={{ ...inputStyle, height: '100px', resize: 'none' }}
          />
          <div style={{ display: 'flex', gap: '10px' }}>
            <button 
              onClick={submit} 
              style={{ 
                flex: 2, padding: '12px', background: '#1abc9c', color: '#fff', 
                border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold'
              }}
            >
              {editId ? 'Зберегти зміни' : 'Додати в перелік'}
            </button>
            {editId && (
              <button 
                onClick={cancelEdit} 
                style={{ 
                  flex: 1, padding: '12px', background: '#ccc', color: '#333', 
                  border: 'none', borderRadius: '8px', cursor: 'pointer' 
                }}
              >
                Скасувати
              </button>
            )}
          </div>
        </div>
      </div>

      <h3 style={{ marginBottom: '20px' }}>📋 Поточні послуги ({services.length})</h3>
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', 
        gap: '20px' 
      }}>
        {currentServices.map(s => (
          <div key={s.id} style={{
            background: '#fff', padding: '20px', borderRadius: '12px',
            border: editId === s.id ? '2px solid #1abc9c' : '1px solid #eee',
            boxShadow: '0 2px 6px rgba(0,0,0,0.03)',
            display: 'flex', flexDirection: 'column', justifyContent: 'space-between'
          }}>
            <div>
              <h4 style={{ margin: '0 0 10px 0', color: '#1abc9c', fontSize: '17px' }}>{s.title}</h4>
              {s.description && (
                <p style={{ fontSize: '14px', color: '#666', lineHeight: '1.5', margin: 0 }}>
                  {s.description}
                </p>
              )}
            </div>
            
            <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <button 
                onClick={() => startEdit(s)}
                style={{ 
                  background: 'none', border: '1px solid #1abc9c', color: '#1abc9c',
                  padding: '5px 12px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px'
                }}
              >
                Редагувати
              </button>
              <button 
                onClick={() => remove(s.id)} 
                style={{ 
                  background: 'none', border: '1px solid #dc3545', color: '#dc3545',
                  padding: '5px 12px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px'
                }}
              >
                Видалити
              </button>
            </div>
          </div>
        ))}
      </div>

      {totalPages > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginTop: '40px' }}>
          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i + 1}
              onClick={() => { setCurrentPage(i + 1); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
              style={{
                width: '35px', height: '35px', borderRadius: '6px', border: '1px solid #ddd',
                backgroundColor: currentPage === i + 1 ? '#1abc9c' : '#fff',
                color: currentPage === i + 1 ? '#fff' : '#333',
                cursor: 'pointer', fontWeight: 'bold'
              }}
            >
              {i + 1}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

// --- Стилі ---
const inputStyle = {
  padding: '12px',
  borderRadius: '8px',
  border: '1px solid #ddd',
  fontSize: '15px',
  outline: 'none',
  width: '100%',
  boxSizing: 'border-box' as const
};

const modalOverlayStyle: React.CSSProperties = {
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
  justifyContent: 'center', alignItems: 'center', zIndex: 1000
};

const modalContentStyle: React.CSSProperties = {
  background: '#fff', padding: '25px', borderRadius: '15px',
  maxWidth: '400px', width: '90%', boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
  textAlign: 'center' as const
};

const primaryBtnStyle = {
  padding: '8px 20px', background: '#1abc9c', color: '#fff',
  border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' as const
};

const secondaryBtnStyle = {
  padding: '8px 20px', background: '#eee', color: '#333',
  border: 'none', borderRadius: '6px', cursor: 'pointer'
};